import { Outlet } from 'react-router'
import { TicketDrawer } from './tickets/TicketDrawer.tsx'
import { useCloseTicket, useTicketParam } from './tickets/useTicketParam.ts'

/** Wraps every HR desk page so `?ticket=HR-1001` opens the drawer over any of them. */
export function HrDeskLayout() {
  const key = useTicketParam()
  const close = useCloseTicket()
  return (
    <>
      <Outlet />
      {key && <TicketDrawer key={key} ticketKey={key} onClose={close} />}
    </>
  )
}
